import { Command } from '@ckeditor/ckeditor5-core';
export default class InsertEmbedCodeCommand extends Command {
    execute() {
        this.editor.model.change((writer) => {
            this.editor.model.insertContent(createEmbedCode(writer));
        });
    }
    refresh() {
        const model = this.editor.model;
        this.isEnabled = true;
    }
}
function createEmbedCode(writer) {
    const embedCode = writer.createElement('embedCode');
    const embedCodeContent = writer.createElement('embedCodeContent');
    writer.append(embedCodeContent, embedCode);
    return embedCode;
}
